import React from 'react';

import { useTranslation } from 'react-i18next';

type SignupProgressBarProps = {
  current: number;
  total: number;
};

/** 모달 맨 위 가장자리 진행 막대 + 좌상단 단계 태그 — 둥근 모서리에 맞춰 잘리고, 스크롤돼도 막대는 고정 */
const SignupProgressBar = ({ current, total }: SignupProgressBarProps) => {
  const { t } = useTranslation('auth');

  return (
    <>
      <div
        role="progressbar"
        aria-label={t('signup.stepIndicator', { current, total })}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-valuenow={current}
        className="sticky top-0 z-10 flex h-1.5 w-full shrink-0 gap-x-0.5 bg-white"
      >
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={`h-full flex-1 transition-colors duration-300 ${index < current ? 'bg-primary' : 'bg-gray-20'}`}
          />
        ))}
      </div>
      <span className="absolute left-6 top-6 rounded-full bg-primaryLight px-2.5 py-1 text-[11px] font-semibold text-primary">
        {current}/{total}
      </span>
    </>
  );
};

export default SignupProgressBar;
